export default "__VITE_PUBLIC_ASSET__a60e7d55__"